<div cdkFocusInitial tabindex="0">
    <ap-calendar
        cdkTrapFocus
        [id]="datepicker.id"
        [ngClass]="datepicker.panelClass()"
        [startAt]="datepicker.startAt"
        [startView]="datepicker.startView()"
        [minDate]="datepicker._minDate"
        [maxDate]="datepicker._maxDate"
        [dateFilter]="datepicker._dateFilter"
        [headerComponent]="datepicker.calendarHeaderComponent()"
        [selected]="datepicker._selected"
        [@fadeInCalendar]="'enter'"
        (selectedChange)="datepicker._select($event)"
        (yearSelected)="datepicker._selectYear($event)"
        (monthSelected)="datepicker._selectMonth($event)"
        (_userSelection)="datepicker.close()"
    >
    </ap-calendar>
</div>
